import {getUserInfoFromBdd, sendConversationToBdd, sendInfoToLlm} from "@/lib/api-chatbot-client";

export function useQuestionnaire(questions) {
    const QUESTION_KEYS = ["nom", "prenom", "age", "sexe", "taille", "poids", "objectif"]

    const handleQuestionnaireResponse = async (
        input,
        currentStep,
        userId,
        sessionId,
        userInfo,
        setMessages,
        setUserInfo,
        setCurrentStep,
        setIsTyping
    ) => {
        // Vérifier que sessionId et userId sont définis
        if (!sessionId || !userId) {
            console.warn("⚠️ sessionId ou userId not ready yet")
            return
        }

        const keys = QUESTION_KEYS
        const currentKey = keys[currentStep]
        const currentQuestion = questions[currentStep].text
        const step = currentStep + 1

        sendConversationToBdd('bot', currentQuestion, userId, sessionId)
        sendConversationToBdd('user', input, userId, sessionId)

        try {
            const result = await sendInfoToLlm(currentQuestion, input, step)
            const extracted = result.extracted
            const newUserId = result.user_id || userId

            if (step === 1 && newUserId) {
                // Le backend retourne le nouvel user_id créé
            }

            setUserInfo({ ...userInfo, [currentKey]: extracted })

            try {
                const dbInfo = await getUserInfoFromBdd(newUserId || userId)
                if (dbInfo && !dbInfo.error) {
                    setUserInfo(dbInfo)
                    console.log("Infos récupérées de la BDD:", dbInfo)
                }
            } catch (err) {
                console.error('Erreur BDD:', err)
            }

            const nextStep = currentStep + 1
            setCurrentStep(nextStep)

            setIsTyping(true)
            setTimeout(() => {
                if (nextStep < questions.length) {
                    const nextQuestion = questions[nextStep]
                    setMessages(prev => [...prev, {
                        id: prev.length + 1,
                        text: nextQuestion.text,
                        sender: 'bot',
                        timestamp: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                    }])
                } else {
                    setMessages(prev => [...prev, {
                        id: prev.length + 1,
                        text: `Merci ${userInfo.nom}! J'ai noté vos infos. Vous pouvez maintenant me poser vos questions.`,
                        sender: 'bot',
                        timestamp: new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
                    }])
                }
                setIsTyping(false)
            }, 1000)
        } catch (err) {
            console.error('Erreur questionnaire:', err)
            setIsTyping(false)
        }
    }

    return {
        handleQuestionnaireResponse
    }
}